import EmptyTemplates from './EmptyTemplates';

export default EmptyTemplates;
